import React from 'react';

/**
 *
 * It caches error in child component tree and display a fallback UI instead of crashing the whole app.
 * [Read more]{@link https://reactjs.org/docs/error-boundaries.html}
 *
 *<br> <br>
 * **Example**
 * ```js
 *  <ErrorBoundary> <Component /> <ErrorBoundary />
 * ```
 * @component
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log('my custom error: ', error, errorInfo);

    // logErrorToMyService(error, errorInfo);
  }

  /* return of ErrorBoundary */
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong. Reload the app.</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
